/**
 * Claim Stripe entitlements after login (billing/audit rows created before auth.users).
 * Invokes claim-entitlements edge function.
 */

import { supabase } from "@/lib/supabaseClient";

export async function claimEntitlements(opts?: {
  stripeCustomerId?: string;
  domain?: string;
}): Promise<{ success: boolean; claimed?: Record<string, number>; error?: string }> {
  try {
    const { data, error } = await supabase.functions.invoke("claim-entitlements", {
      body: {
        stripe_customer_id: opts?.stripeCustomerId,
        domain: opts?.domain,
      },
    });
    if (error) {
      console.warn("[claimEntitlements]", error.message);
      return { success: false, error: error.message };
    }
    return data?.success
      ? { success: true, claimed: data.claimed }
      : { success: false, error: data?.error || "claim failed" };
  } catch (err) {
    const message = err instanceof Error ? err.message : "claim failed";
    console.warn("[claimEntitlements]", message);
    return { success: false, error: message };
  }
}
